// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1rSwn","title":"InfoRow_title__17jh4"};